import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600 px-3 mb-2" }, " Informe seu usuário (CPF/CNPJ ou celular). Enviaremos um link para você criar uma nova senha no e-mail cadastrado. ", -1)
const _hoisted_3 = { class: "px-3 pt-3" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-center gap-2"
}
const _hoisted_5 = {
  key: 1,
  class: "flex items-center justify-center gap-2"
}
const _hoisted_6 = {
  key: 1,
  class: "w-full px-3"
}
const _hoisted_7 = { class: "flex items-start gap-3 rounded-lg border border-gray-200 bg-gray-50 p-4" }
const _hoisted_8 = { class: "text-sm text-gray-700" }

import { ref, watch } from "vue";
import DialogModal from "../Modal/DialogModal.vue";
import ListHeader from "../ListHeader.vue";
import InputText from "../inputs/InputText.vue";
import helpers from "@/helpers";
import store from "@/store";
import { getThemeColor } from "@/branding";


export default /*#__PURE__*/_defineComponent({
  __name: 'EsqueciSenha',
  props: {
  show: {
    type: Boolean,
    default: false,
  },
  usuarioInicial: {
    type: String,
    default: "",
  },
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;





const theme = getThemeColor();

const usuario = ref("");
const enviando = ref(false);
const emailEnviado = ref(false);
const mensagem = ref("");

watch(
  () => props.show,
  (aberto) => {
    if (aberto) {
      usuario.value = props.usuarioInicial;
      emailEnviado.value = false;
      mensagem.value = "";
    }
  }
);

const enviar = async () => {
  if (!usuario.value) {
    helpers.mensagemErro("Informe o usuário.");
    return;
  }

  enviando.value = true;
  try {
    const retorno = await store.dispatch("esqueciSenha", usuario.value);

    if (retorno?.success) {
      emailEnviado.value = true;
      mensagem.value =
        retorno.mensagem ??
        "Se o usuário existir e tiver e-mail cadastrado, o link de redefinição de senha será enviado.";
    }
  } finally {
    enviando.value = false;
  }
};

const fechar = () => {
  emit("close", true);
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_t_button = _resolveComponent("t-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(DialogModal, { show: __props.show }, {
      title: _withCtx(() => [
        _createVNode(ListHeader, { label: "Esqueci a senha" })
      ]),
      content: _withCtx(() => [
        (!emailEnviado.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(InputText, {
                name: "usuario",
                label: "Usuário",
                tclass: "w-full",
                modelValue: usuario.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((usuario).value = $event)),
                placeholder: "Digite seu usuário"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_t_button, {
                  type: "button",
                  disabled: enviando.value,
                  class: _normalizeClass(["w-full py-2.5 text-white font-semibold rounded-lg shadow-md focus:outline-none disabled:opacity-70 disabled:cursor-not-allowed", `bg-${_unref(theme)}-800 hover:bg-${_unref(theme)}-900`]),
                  onClick: enviar
                }, {
                  default: _withCtx(() => [
                    (enviando.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: "sync-alt",
                            spin: ""
                          }),
                          _createTextVNode(" Enviando... ")
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                          _createVNode(_component_font_awesome_icon, { icon: "envelope" }),
                          _createTextVNode(" Enviar link de redefinição ")
                        ]))
                  ]),
                  _: 1
                }, 8, ["disabled", "class"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "envelope",
                  class: _normalizeClass(["mt-1 text-xl", `text-${_unref(theme)}-800`])
                }, null, 8, ["class"]),
                _createElementVNode("p", _hoisted_8, _toDisplayString(mensagem.value), 1)
              ])
            ]))
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_t_button, {
          onClick: fechar,
          color: "gray"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Fechar")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})